var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"container"}},[_c('div',[_vm._m(0),_c('div',{ref:"map",staticClass:"map",attrs:{"id":"map"}})]),_c('MapLegend')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mapboxgl-ctrl-bottom-right"},[_c('a',{attrs:{"href":"https://www.gc.cuny.edu/CUR","target":"_blank"}},[_c('img',{attrs:{"src":"cuny-gc-logo.png"}})])])
}]

export { render, staticRenderFns }